import { Rectangle } from "../../maths/Rectangle";
import { ColorUtils } from "../../utils/ColorUtils";
import { Pool } from "../../utils/Pool";
export class DrawImageCmd {
    constructor() {
        this.color = 0xffffffff;
    }
    static create(texture, x, y, width, height, color) {
        let cmd = Pool.getItemByClass("DrawImageCmd", DrawImageCmd);
        cmd.texture = texture;
        texture && texture._addReference();
        cmd.x = x !== null && x !== void 0 ? x : 0;
        cmd.y = y !== null && y !== void 0 ? y : 0;
        cmd.width = width !== null && width !== void 0 ? width : texture.sourceWidth;
        cmd.height = height !== null && height !== void 0 ? height : texture.sourceHeight;
        cmd.color = color != null ? ColorUtils.create(color).numColor : 0xffffffff;
        return cmd;
    }
    recover() {
        this.texture && this.texture._removeReference();
        this.texture = null;
        Pool.recover("DrawImageCmd", this);
    }
    run(context, gx, gy) {
        let tex = this.texture;
        if (!tex)
            return;
        let x = this.x, y = this.y, w = this.width, h = this.height;
        let wRate = w / tex.sourceWidth;
        let hRate = h / tex.sourceHeight;
        w = tex.width * wRate;
        h = tex.height * hRate;
        x += tex.offsetX * wRate;
        y += tex.offsetY * hRate;
        context.drawTexture(this.texture, x + gx, y + gy, w, h, this.color);
    }
    getBounds(assembler) {
        Rectangle.TEMP.setTo(this.x, this.y, this.width, this.height).getBoundPoints(assembler.points);
    }
    get cmdID() {
        return DrawImageCmd.ID;
    }
}
DrawImageCmd.ID = "DrawImage";
